<template>
  <div class="homebase-background">
    <loading-overlay v-if="!isSearchComponentReady" />
    <transition name="fade">
      <div>
        <div><outage-banner-card></outage-banner-card></div>
        <div><campaign-card /></div>
        <div v-show="isSearchComponentReady" class="search-wrapper" :class="{ 'search-results-visible': searchTerm }">
          <enterprise-search
            v-if="authResponse"
            :env="appEnv"
            :es-user-access-token="authResponse.accessToken"
            :es-user-id-token="authResponse.idToken"
            :user-id="authResponse.user.userName"
            :user-email="authResponse.user.email"
            :enable-url-params="false"
            :disable-filters="false"
            :input-placeholder="'Find answers, applications, articles, news and more...'"
            :customize-search="true"
            :enable-employee-hub-search="true"
            :key="componentKey"
            @search-keyword-changed="searchKeywordChanged"
            @web-component-success="onESComponentReady"
            @web-component-error="onESComponentError"
          />
        </div>
        <div v-show="!searchTerm" class="homebase-container container">
          <homebase-home />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as CONSTANTS from "@/store/constants";
import UtilityMixin from "../../mixins/globalUtilityMixin";
import { safeImportComponent } from "@/utils/componentImportUtils";

import HomebaseHome from "@/components/homebase/HomebaseHome";
import CampaignCard from "../homebase/CampaignCard";
import OutageBannerCard from "../homebase/OutageBannerCard";
import LoadingOverlay from "@/components/LoadingOverlay";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";

export default {
  name: "HomePage",
  mixins: [UtilityMixin, HomebaseMixpanelMixin],
  components: {
    CampaignCard,
    HomebaseHome,
    OutageBannerCard,
    LoadingOverlay
  },
  computed: {
    ...mapGetters([
      "user",
      "authResponse",
      "isLoading",
      "userCriteria",
    ]),
  },
  data() {
    return {
      searchTerm: "",
      appEnv: CURRENT_ENV,
      CONSTANTS,
      componentKey: 0,
      isSearchComponentReady: false,
    };
  },
  created() {
    this.trackAutodeskOnePageHit("Home");
    safeImportComponent(ES_COMPONENTS_URL + "/enterprisesearch.umd.min.js");
  },
  methods: {
    ...mapActions([
      "fetchUserCriteria",
    ]),
    onESComponentReady(event) {
      this.isSearchComponentReady = true;
    },
    onESComponentError(error) {
      this.isSearchComponentReady = true;
    },
    searchKeywordChanged(response) {
      if (response && response.detail && response.detail[0] !== undefined) {
        this.searchTerm = response.detail[0] || "";
      } else {
        this.searchTerm = "";
      }
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 1s;
  transition-property: opacity;
  transition-timing-function: ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.lumi-img {
  height: 60px;
  margin: -10px 0 -18px -8px;
}
</style>

<style>
.homebase-background {
  background: #f5f5f5 !important;
}
.search-wrapper {
  margin-top: -56px;
  min-height: 136px;
}
.search-results-visible {
  min-height: 70vh !important;
}
.search-results-stats-card-txt {
  color: #666 !important;
}
body:has(.homebase-background) .aone-footer-wrapper {
  background: #f5f5f5 !important;
}
</style>

<style scoped>
/* search placeholder styling */
.search-wrapper :deep(.search-input::placeholder) {
 color: #cccccc !important;
}
/* alignment fixes */
.search-wrapper :deep(.search-card-container) {
  -ms-flex: 0 0 100%;
  -webkit-box-flex: 0;
  flex: 0 0 100%;
  max-width: 100%;
  margin-left: 0%;
}
.search-wrapper :deep(.nav-bar-wrapper) {
  max-width: 1320px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
.search-wrapper :deep(.nav-bar-wrapper > .col-md-6) {
  -ms-flex: 0 0 100%;
  -webkit-box-flex: 0;
  flex: 0 0 100%;
  max-width: 100%;
  margin-left: 0%;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.search-wrapper :deep(nav) {
  background: white !important;
}
.search-wrapper :deep(.bg-white) {
  width: 100%;
  background: none !important;
}
.search-wrapper :deep(.bg-white + .row) {
  max-width: 1320px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  background: none !important;
}
.search-wrapper :deep(.search-input-wrapper) {
  max-width: 1320px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
.search-wrapper :deep(.search-card-container) > .row {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.search-wrapper :deep(.search-card-container):has(.search-results-loading-panel) {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
</style>

<style scoped src="../../../static/aone-theme.css"></style>
